import { ActiveState, EntityState, EntityStore } from '@datorama/akita';
import { TextKeys } from '../../../i18n/text-keys';
import { OperationListItemModel } from '../../../models/operation/operation-list-item.model';
import { getTableColumns } from './operation-table-columns';

/**
 * operation Entity Store. Used to display list of operation.
 */
export interface OperationItemsState
  extends EntityState<OperationListItemModel, number>,
    ActiveState {
  page: number;
  pageSize: number;
  lastPage: boolean;
  textOperation: string;
}

// @Injectable({
//     providedIn: 'root'
// })
// @StoreConfig()
export class OperationItemsStore extends EntityStore<OperationItemsState> {
  constructor(name: string) {
    super(
      {
        page: 0,
        pageSize: 50,
        lastPage: false,
        columns: getTableColumns(),
        filterOptions: {
          operation: {
            name: TextKeys.operation.title,
            selected: false,
          },
          note: {
            name: TextKeys.operation.note,
            selected: false,
          },
          costCenterNumber: {
            name: TextKeys.costCenter.numberShort,
            selected: false,
          },
          costCenterName: {
            name: TextKeys.costCenter.title,
            selected: false,
          },
        },
        filterValue: '',
      },
      { name, idKey: 'aksPlanID' }
    );
  }
}
